<template>
  <SSection
    v-for="(item, index) in items"
    :key="index"
    :title="item.title"
    :has-separator="false"
    :full-width="false"
    :centered="true"
  >
    <SShortDescription :text="item.description.text" />
  </SSection>
</template>

<script setup lang="ts">
import type { propsInterface as sShortDescriptionProps } from '~~/modules/design-system/sections/s-short-description/s-short-description.vue'

type sShortDescription = {
  title: string
  description: sShortDescriptionProps
}
export interface propsInterface {
  items: sShortDescription[]
}

defineProps<propsInterface>()
</script>
